import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

interface OwnProps {
  children: React.ReactNode;
}
type PublicProps = OwnProps;
type Props = PublicProps;

const ScrollToTop: React.SFC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const prevPathname = usePrevious(pathname);

  useEffect(() => {
    if (pathname !== prevPathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname, prevPathname]);

  return <>{children}</>;
};

export default ScrollToTop as React.ComponentType<PublicProps>;
